<template>
  <v-layout>
    <dialog-wrapper :visible="dialog">
      <v-dialog v-model="dialog" max-width="500" persistent>
        <v-card @keyup.enter="blurAndSaveNewProvider">
          <v-card-title class="headline">
            {{ $t('manageProvidersModal.createNewProvider') }}
          </v-card-title>
          <v-form ref="form" @submit.prevent>
            <v-flex xs12 style="margin: 0 16px;">
              <v-text-field
                ref="providerName"
                v-model="providerName"
                :label="$t('manageProvidersModal.providerName')"
                :name="$t('manageProvidersModal.providerName')"
                :rules="[rules.lengthNotGreaterThan, rules.required]"
              />
            </v-flex>
          </v-form>
          <v-card-actions>
            <v-spacer />
            <v-btn
              flat="flat"
              @click="close"
            >
              {{ $t('common.cancel') }}
            </v-btn>
            <v-btn
              color="primary"
              :loading="loading > 0"
              @click="saveNewProvider"
            >
              {{ $t('common.confirm') }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </dialog-wrapper>
  </v-layout>
</template>

<script>
import gql from 'graphql-tag';
import NotificationService from '@/services/NotificationService';
import ErrorHandler from '@/services/ErrorHandler';
import ValidationService from '@/services/ValidationService';
import DialogWrapper from '../../../common/dialog-wrapper/DialogWrapper.vue';

export default {
  name: 'NewProviderModal',
  components: { DialogWrapper },
  data() {
    return {
      dialog: false,
      loading: 0,
      providerName: '',
      rules: {
        required: ValidationService.rules.required(),
        lengthNotGreaterThan: ValidationService.rules.lengthNotGreaterThan('Value must not exceed 100 characters.', 100),
      },
    };
  },
  methods: {
    open() {
      this.dialog = true;
    },
    close() {
      this.dialog = false;
      this.$refs.form.reset();
    },
    blurAndSaveNewProvider() {
      document.activeElement.blur();
      this.saveNewProvider();
    },
    async saveNewProvider() {
      const newProviderNameValid = ValidationService.validate(
        Object.keys(this.$refs)
          .filter(k => k === 'providerName')
          .map(k => this.$refs[k]),
      );

      if (newProviderNameValid) {
        try {
          this.loading = 1;
          const result = await this.$apollo.mutate({
            mutation: gql`mutation CreateNewProviderMutation($name: String!) {
              createNewProvider(name: $name)
            }`,
            variables: {
              name: this.providerName.trim(),
            },
          });

          if (result) {
            this.$emit('new-provider-created', this.providerName.trim());
            this.close();
          }
        } catch (error) {
          ErrorHandler.handleApolloError(error);
        } finally {
          this.loading = 0;
        }
      } else {
        setTimeout(() => {
          const invalidFieldNames = [...new Set(ValidationService.getInvalidFieldNames())];
          NotificationService.showAlert({
            message: this.$t('common.invalidFields', { fields: invalidFieldNames.join(', ') }),
            level: 'error',
          });
        });
      }
    },
  },
};
</script>
